export default function InvestorsDeck() {
  return (
    <div>
      <embed src="" width="800px" height="2100px" />
    </div>
  );
}
